// src/routes/RoleBasedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const RoleBasedRoute = ({ allowedRoles = [] }) => {
  const { user } = useAuth()

  return allowedRoles.includes(user?.role) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  )
}

export default RoleBasedRoute
